import React from 'react';

import { InstallDocumentTypes } from 'types';

import { DefaultDocumentRenderer } from './DefaultDocumentRenderer';
import { documentRendererRegistry, DocumentRendererProps } from './DocumentRendererRegistry';

interface DocumentRendererFactoryProps extends DocumentRendererProps {
  documentType: InstallDocumentTypes;
}

export const DocumentRendererFactory: React.FC<DocumentRendererFactoryProps> = ({
  documentType,
  modelOutput,
  accountId,
  panelIndex,
  isOpen,
  onToggle,
  onRefresh,
}) => {
  const RendererComponent = documentRendererRegistry.getRenderer(documentType);

  if (!RendererComponent) {
    return (
      <DefaultDocumentRenderer
        modelOutput={modelOutput}
        accountId={accountId}
        panelIndex={panelIndex}
        isOpen={isOpen}
        onToggle={onToggle}
        onRefresh={onRefresh}
      />
    );
  }

  return (
    <RendererComponent
      modelOutput={modelOutput}
      accountId={accountId}
      panelIndex={panelIndex}
      isOpen={isOpen}
      onToggle={onToggle}
      onRefresh={onRefresh}
    />
  );
};
